<i class="far fa-crosshairs" data-fa-symbol="crosshairs"></i>

<div id="station-trains-container" #trainTableRows *ngIf="station">

    <div class="filters">
        <button [attr.data-btnId]="getElementId('toggleFilters')" (click)="filterOverlay.toggle($event);"
                class="btn btn-sm btn-outline-primary" style="width: 100%">
          {{'Filters' | translate}}
        </button>
    </div>
    <div id="station-trains-table" role="table" *qmLoading="loading">
      <div class="grid-header" role="columnheader">
        {{'Train' | translate}}
      </div>
      <div class="grid-header" role="columnheader">
        {{'Track' | translate}}
      </div>
      <div class="grid-header" role="columnheader">
        {{'Stop' | translate}}
      </div>
      <div class="grid-header" role="columnheader">
        {{'Route' | translate}}
      </div>
      <div class="grid-header" role="columnheader">
        <i class="far fa-arrow-to-right"></i>
      </div>
      <div class="grid-header" role="columnheader">
        {{'Cause' | translate}}
      </div>

      <ng-template ngFor let-stationTrain let-i="index" [ngForOf]="trains">
        <ng-container *ngIf="trainVisible(stationTrain.train)">
          <!-- TODO: figure out how to use getRowClass for all grid-cell divs at once -->
          <div (click)="onTrainIdClicked(stationTrain)" class="grid-cell clickable" role="cell"
            [ngClass]="getRowClasses(stationTrain, i)">
              <ng-container *ngIf="stationTrain.train.commercialId; else category;">
                {{stationTrain.train.commercialId}}
              </ng-container>
              <ng-template #category>{{stationTrain.train.category}}</ng-template>
              {{stationTrain.train.tripNumber}}
          </div>
          <div class="grid-cell" role="cell"
            [ngClass]="getRowClasses(stationTrain, i)">
              {{stationTrain.track}}
          </div>
          <div class="grid-cell" role="cell"
            [ngClass]="getRowClasses(stationTrain, i)">
              <ng-container *ngIf="!stationTrain.stop; else commercialBlock;">
                  -
                </ng-container>
                <ng-template #commercialBlock>
                  {{stationTrain.commercial ? ('Yes' | translate) : ('No' | translate)}}
                </ng-template>
          </div>
          <div class="grid-cell" role="cell"
            [ngClass]="getRowClasses(stationTrain, i)">{{stationTrain.train.depStation}} - {{stationTrain.train.arrStation}}</div>
          <div class="grid-cell" role="cell"
            [ngClass]="getRowClasses(stationTrain, i)">
              <div *ngIf="showArrivals() && stationTrain.arrival?.schedule">
                  {{stationTrain.arrival?.schedule | qmDateFormat:'HH:mm'}}
                  <ng-container *ngIf="stationTrain.arrival?.actual; else arrElseBlock">
                    {{stationTrain.arrival?.actual | qmDateFormat:'(HH:mm)'}}
                  </ng-container>
                  <ng-template #arrElseBlock>
                  </ng-template>
                </div>
                <div *ngIf="showDepartures() && stationTrain.departure?.schedule">
                  {{stationTrain.departure?.schedule | qmDateFormat:'HH:mm'}}
                  <ng-container *ngIf="stationTrain.departure?.actual; else depElseBlock">
                    {{stationTrain.departure.actual | qmDateFormat:' (HH:mm)'}}
                  </ng-container>
                  <ng-template #depElseBlock>
                  </ng-template>
                </div>
          </div>
          <div class="grid-cell" role="cell"
            [ngClass]="getRowClasses(stationTrain, i)">
              {{getCause(stationTrain)}}
          </div>
        </ng-container>
      </ng-template>

    </div>
</div>

<ng-template #inactive>
  <span class="inactive-dot"></span>
</ng-template>

<qm-overlay-panel #filterOverlay [stickTo]="'left-bottom'" [appendTo]="'body'">
  <div class="btn-group-vertical">
    <button [attr.data-btnId]="getElementId('toggleFilter_' + filter.val.name)"
            *ngFor="let filter of filters | qmMapValues"
            class="btn btn-glass d-flex justify-content-between align-items-center"
            (click)="filter.val.active = !filter.val.active">
      <span *ngIf="filter.val.active; else inactive" class="active-dot"></span>
      <span class="layer-title">
            {{filter.val.name | translate}}
          </span>
    </button>
  </div>
</qm-overlay-panel>
